import {
    FETCH_ACTIONS_REQUEST,
    FETCH_ACTIONS_SUCCESS,
    FETCH_ACTIONS_FAILURE,
} from '../actions/types/actions-action-types';

import { combineReducers } from 'redux';

function isLoading( state = false, action ){
    let newState;
    switch( action.type ){
        case FETCH_ACTIONS_REQUEST:
            newState = true;
            break;
        case FETCH_ACTIONS_SUCCESS:
        case FETCH_ACTIONS_FAILURE:
            newState = false;
            break;
        default:
            return state;
    }

    return newState;
}

function byDomain( state = {}, action ){
    let newState;
    switch( action.type ){
        case FETCH_ACTIONS_SUCCESS:
            newState = action.actions;
            break;
        case FETCH_ACTIONS_REQUEST:
        case FETCH_ACTIONS_FAILURE:
            newState = {};
            break;
        default:
            return state;
    }

    return newState;
}

export default combineReducers( {
    byDomain,
    isLoading,
} );
